/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-27 09:32:54
 * @LastEditors: liangen(80398513)
 * @LastEditTime: 2024-06-19 10:05:27
 * @FilePath: /cem-portal-frontend/src/pages/Survey/TestSurvey/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  defineComponent,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive,
  ref
} from '@vue/composition-api'
import { getQueryString } from '@/utils/utils'
import { useHistory, useRequest } from '@/utils/bhooks'
import {
  checkSurveyDetialService,
  getSurveyTopicLogic,
  getOpenSurvey,
  getSurveyDetialByOutnet,
  querySurveyLanguageList,
  submitSurveyHtmlService
} from '@/services/survey'
import '../common/common.scss'
import './index.scss'
import _ from 'lodash'
import { getRandomList } from '../SurveyManagement/components/SurveyContent/topicCommonUtil'
import NormalSurvey from './NormalSurvey'
import OnePageSurvey from './OnePageSurvey'
import EndAnswer from './EndAnswer'
import moment from 'moment'
import { dealToXss, getUserInfo } from './util'
import { colorMap } from '@/pages/Survey/common/style'
import sourceI18n from '@/locales'
//单独使用i18n --开始
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCookMessages from '@gcommon/gcommon-ui/src/locale/lang/zh-CN'
import enCookMessages from '@gcommon/gcommon-ui/src/locale/lang/en'
import { getAllUrlQuery } from '@/utils/assist'
import TimeEndIcon from '@/assets/images/time_end.png'

Vue.use(VueI18n)

const languageMap = {
  ZH_CN: 'zh',
  ID: 'id',
  EN: 'en',
  TH: 'th',
  FIL: 'fil',
  MS: 'ms',
  VI: 'vi',
  ZHT: 'zht',
  KM: 'km',
  LO: 'lo',
  ES: 'es',
  AR: 'ar',
  PT: 'pt',
  TR: 'tr'
}

const messages = {
  en: {
    ...window.langenUS,
    ...enCookMessages
  },
  es: {
    ...window.langesEs,
    ...enCookMessages
  },
  zh: {
    ...window.langzhCN,
    ...zhCookMessages
  },
  id: {
    ...window.langidID,
    ...enCookMessages
  },
  th: {
    ...window.langthTH,
    ...enCookMessages
  },
  fil: {
    ...window.langfilFil,
    ...enCookMessages
  },
  pt: {
    ...window.langptPt,
    ...enCookMessages
  },
  ms: {
    ...window.langmsMs,
    ...enCookMessages
  },
  vi: {
    ...window.langviVI,
    ...enCookMessages
  },
  zht: {
    ...window.langzhTW,
    ...enCookMessages
  },
  lo: {
    ...window.langloLO,
    ...enCookMessages
  },
  km: {
    ...window.langvikmKM,
    ...enCookMessages
  },
  ar: {
    ...window.langAr,
    ...enCookMessages
  },
  tr: {
    ...window.langtrTR,
    ...enCookMessages
  }
}

export const i18n = new VueI18n({
  locale: 'zh', //使用后端字段作为判断依据
  messages
})

//单独使用i18n --结束
const no_order = [5, 15] //当是分页和段落说明时不需要序号
const TestSurvey = defineComponent({
  setup(props, context) {
    const urlInstanceId = ref('')
    const preview = getQueryString('preview')
    const instance = getCurrentInstance()
    const router = useHistory()
    const startTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
    const languageList = ref([])
    let lanugageValue = ref('')
    let keyForRender = ref(true)
    //获取url上的surveyId
    const surveyId = getQueryString('surveyId')
    const isDraft = getQueryString('isDraft') === 'true'
    const isTest = Boolean(getQueryString('isTest'))
    const triggerId = getQueryString('ta_id')
    const surveyIdFromUrl = getQueryString('id')
    const code = router?.history?.current?.params?.collector //判断是否是正式问卷
    const isReadOnly = router?.history?.current?.meta?.isReadOnly
    const { state: surveyData, run: getSurveyData } = useRequest(
      !isTest ? getSurveyDetialByOutnet : checkSurveyDetialService
    )
    const { state: surveyRule, run: getSurveyRule } =
      useRequest(getSurveyTopicLogic)
    const { state: getDetailLanguauesState, run: getDetailLanguauesRun } =
      useRequest(querySurveyLanguageList)
    const { state: getOpenSurveyState, run: getOpenSurveyRun } =
      useRequest(getOpenSurvey)
    const state = reactive({
      surveyDetial: {
        topics: [],
        surveyConfig: {
          isOnePageOneTopic: false
        }
      },
      renderTopics: [],
      pageIndex: 0, //非一页一题时，题目块索引
      pindex: -1, //一页一题时，当前题目索引
      isEnd: false, //是否已结束答题
      endStr: '',
      lastPageTopic: {
        topicSetting: {}
      },
      surveyRule: [],
      researchIsEnd: false,
      answerCounts: 0
    })

    const templateRender = (template, templateDic) => {
      const reg = /\$\{\w+\.(\w+)\}/
      if (reg.test(template)) {
        const lsKey = reg.exec(template)?.[1]
        template = template?.replace(reg, templateDic[lsKey as string] || '')
        return templateRender(template, templateDic)
      }
      return template
    }

    const replaceTemplate = (data) => {
      const templateDic = getAllUrlQuery()
      data.surveyConfig.surveyContent = templateRender(
        data.surveyConfig.surveyContent,
        templateDic
      )
      data.surveyConfig.foreword = templateRender(
        data.surveyConfig.foreword,
        templateDic
      )
      data.surveyConfig.foreword = data.surveyConfig.foreword?.replace(
        /\f\t\f/g,
        '</br>'
      ) //特殊处理
      data.topics?.forEach((item) => {
        item.topicSetting.topicName = templateRender(
          item.topicSetting.topicName,
          templateDic
        )
        item.topicName = templateRender(
          item.topicSetting.topicName,
          templateDic
        )
        //对1.0的特殊问卷做替换
        if ([1430, 1416, 1415, 1417, 1428].includes(data.surveyConfig.bizId)) {
          if (templateDic['actionName']) {
            item.topicName = item.topicName.replace(
              /OnePlus/g,
              templateDic['actionName']
            )
            item.topicName = item.topicName.replace(
              /Enco X1/g,
              templateDic['actionName']
            )
          }
        }
        item.topicSetting.topicRemark = templateRender(
          item.topicSetting.topicRemark,
          templateDic
        )
        item.matrixTopics?.forEach((sonItem) => {
          sonItem.topicName = templateRender(sonItem.topicName, templateDic)
          if (
            [1430, 1416, 1415, 1417, 1428].includes(data.surveyConfig.bizId)
          ) {
            if (templateDic['actionName']) {
              sonItem.topicName = sonItem.topicName.replace(
                /OnePlus/g,
                templateDic['actionName']
              )
              sonItem.topicName = sonItem.topicName.replace(
                /Enco X1/g,
                templateDic['actionName']
              )
            }
          }
        })
      })
    }

    const dealSurveyData = () => {
      let data = isTest
        ? surveyData.data.data || {}
        : surveyData.data.data?.surveyDetailDto || {}
      state.answerCounts = data.answeredTimes || 0
      for (const [key, value] of Object.entries(
        colorMap[data.surveyConfig.theme]
      )) {
        document
          .getElementsByTagName('body')[0]
          .style.setProperty(key, value as string)
      }
      //对问卷数据进行xxr处理
      data = dealToXss(data)
      let order = 0 // 用于前端序号
      data.topics = data.topics.map((item) => {
        let titleTips = '' //题目提示语
        if (item.topicSetting.textLessThan) {
          titleTips = `${i18n.t('survy.mostEnter')} ${
            item.topicSetting.textLessThan
          } ${i18n.t('survy.char')}`
        }
        if (item.topicSetting.maxAppendixNum && item.topicType === 19) {
          //附件
          titleTips = `${i18n.t('survy.mostupl')} ${
            item.topicSetting.maxAppendixNum
          } ${i18n.t('survy.files')}`
        }
        //内部是否有选项随机排列
        if (item.topicSetting.isRandomOrder) {
          item.topicSetting.topicOptionSetting = getRandomList(
            item.topicSetting.topicOptionSetting
          )
        }
        let isNeedOrder = no_order.includes(item.topicType)
        if (!isNeedOrder) {
          order++
        }
        //当题目为矩阵题时，答案需要维护一个数组对象
        let matrixValue: any[] = []
        ;(item.matrixTopics || []).forEach((element) => {
          matrixValue.push({
            subTopicId: element.id,
            value: item.topicType == 9 ? [] : ''
          })
        })

        let inputValueObj = {}
        //正对单选、多选存在不多输入框的处理
        ;(item.topicSetting.topicOptionSetting || []).forEach((element) => {
          inputValueObj['inputValue_' + element.optionId] = ''
          inputValueObj['inputErrorTips_' + element.optionId] = ''
        })

        // 答案初始化  TODO
        const answerDetailDtos = data.answerDetailDtos || []
        answerDetailDtos.forEach((sonItem) => {
          if ([1, 2, 12, 20].includes(item.topicType)) {
            //选择处理
            if (item.id === sonItem.topicId) {
              if (2 === item.topicType) {
                let opValue: any[] = []
                inputValueObj['inputValue_' + sonItem.optionId] =
                  sonItem.answerContent
                opValue.push(parseInt(sonItem.optionId))
                if (item?.values?.length) {
                  item.values = item.values.concat(opValue)
                } else {
                  item.values = opValue
                }
              } else {
                item.value = parseInt(sonItem.optionId)
                inputValueObj['inputValue_' + sonItem.optionId] =
                  sonItem.answerContent
              }
            }
          } else if (
            [4, 8, 10, 11, 17, 19, 21, 22, 23].includes(item.topicType)
          ) {
            //文本处理
            if (item.id === sonItem.topicId) {
              if (item.topicType === 17) {
                item.value =
                  isNaN(parseInt(sonItem.answerContent)) ||
                  parseInt(sonItem.answerContent) === -1
                    ? sonItem.answerContent
                    : parseInt(sonItem.answerContent)
              }
              // else if (item.topicType === 19) {
              //   item.value = JSON.parse(sonItem.answerContent)
              // }
              else if (item.topicType === 21) {
                item.values = sonItem.answerContent
                  ? sonItem.answerContent.split('/')
                  : []
              } else {
                item.value = sonItem.answerContent
              }
            }
          } else if ([3, 9, 14, 18].includes(item.topicType)) {
            //矩阵处理
            if (item.id == sonItem.topicParentId) {
              if ([9].includes(item.topicType)) {
                if (
                  matrixValue.some((ele) => ele.subTopicId === sonItem.topicId)
                ) {
                  let opValue: any
                  item.topicSetting.topicOptionSetting.forEach((choseItem) => {
                    if (choseItem.optionName === sonItem.optionName) {
                      opValue = choseItem.optionId
                    }
                  })
                  matrixValue.forEach((ele) => {
                    if (ele.subTopicId === sonItem.topicId) {
                      ;(ele.value as string[]).push(opValue)
                    }
                  })
                } else {
                  let opValue: any
                  item.topicSetting.topicOptionSetting.forEach((choseItem) => {
                    if (choseItem.optionName === sonItem.optionName) {
                      opValue = choseItem.optionId
                    }
                  })
                  matrixValue.forEach((iitem) => {
                    if (iitem.subTopicId === sonItem.topicId) {
                      iitem.value = [opValue]
                    }
                  })
                  // matrixValue.push({
                  //   subTopicId: sonItem.topicId,
                  //   value: [opValue]
                  // })
                }
              } else if ([3].includes(item.topicType)) {
                let opValue: any
                item.topicSetting.topicOptionSetting.forEach((choseItem) => {
                  if (choseItem.optionName === sonItem.optionName) {
                    opValue = choseItem.optionId
                  }
                })
                matrixValue.forEach((iitem) => {
                  if (iitem.subTopicId === sonItem.topicId) {
                    iitem.value = opValue
                  }
                })
                // matrixValue.push({
                //   subTopicId: sonItem.topicId,
                //   value: opValue
                // })
              } else if ([18].includes(item.topicType)) {
                // 先匹配
                matrixValue.forEach((iitem) => {
                  if (iitem.subTopicId === sonItem.topicId) {
                    iitem.value =
                      isNaN(parseInt(sonItem.answerContent)) ||
                      parseInt(sonItem.answerContent) === -1
                        ? sonItem.answerContent
                        : parseInt(sonItem.answerContent)
                  }
                })
                // matrixValue.push({
                //   subTopicId: sonItem.topicId,
                //   value:
                //     isNaN(parseInt(sonItem.answerContent)) ||
                //     parseInt(sonItem.answerContent) === -1
                //       ? sonItem.answerContent
                //       : parseInt(sonItem.answerContent)
                // })
              } else {
                matrixValue.forEach((iitem) => {
                  if (iitem.subTopicId === sonItem.topicId) {
                    iitem.value =
                      isNaN(parseInt(sonItem.answerContent)) ||
                      parseInt(sonItem.answerContent) === -1
                        ? sonItem.answerContent
                        : parseInt(sonItem.answerContent)
                  }
                })
                // matrixValue.push({
                //   subTopicId: sonItem.topicId,
                //   value: sonItem.answerContent
                // })
              }
              matrixValue.sort(
                (item1, item2) => item1.subTopicId - item2.subTopicId
              ) //内部渲染用的是index。。。所以排序
              item.matrixValue = matrixValue
            }
          } else {
          }
        })
        return Object.assign(
          {},
          {
            order,
            isShowOrder: !data.surveyConfig.isHiddenTopicNum,
            values: [],
            value: '',
            ...inputValueObj,
            isShowTitleError: false,
            // titleErrorTips: '这道题未答完哦!',
            titleErrorTips: i18n.t('survy.unfinished'),
            matrixValue,
            titleTips,
            display: true
          },
          item
        )
      })
      replaceTemplate(data)
      state.surveyDetial = data
    }

    const logCommit = () => {
      // 上报html日志
      submitSurveyHtmlService({
        documentUri: window?.location?.href,
        htmlContent: document.getElementById('app')?.innerText
      })
    }

    onMounted(async () => {
      getUserInfo()
      //等待联调，增加params参数，添加了languageValue的值，这个是有初值的，注意，iframe的情况下，初值是问卷值，否则是调研默认值
      let params = !isTest
        ? {
            collectorPath: code,
            triggerId: triggerId ? triggerId : 0
          }
        : {
            isDraft,
            surveyId
            // languageCode:
          }
      let pageLanguageCode = getQueryString('languageCode')
      // 获取问卷实力id
      const instanceId = getQueryString('instanceId')
      urlInstanceId.value = instanceId || ''
      let tid = getQueryString('tid')
      // console.log(code)
      if (pageLanguageCode && code) {
        params['languageCode'] = pageLanguageCode
      }
      if (tid && code) {
        params['feedbackId'] = tid
      }

      // 临时处理
      const finParams = JSON.parse(JSON.stringify(params))
      if (!!triggerId) {
        finParams.id = surveyIdFromUrl
      }

      const promiseList = isTest
        ? [
            getSurveyData(
              instanceId ? Object.assign({}, params, { instanceId }) : params
            ),
            getSurveyRule(params),
            getDetailLanguauesRun(params)
          ]
        : [
            getSurveyData(
              instanceId
                ? Object.assign({}, finParams, { instanceId })
                : finParams
            )
          ]
      Promise.all(promiseList).then((res) => {
        //判断调研是否已经结束
        lanugageValue.value =
          pageLanguageCode ||
          (isTest
            ? surveyData.data?.data?.languageCode
            : surveyData.data?.data?.surveyDetailDto?.languageCode)

        if (surveyData.data?.code === 5011) {
          state.researchIsEnd = true
          i18n.locale = languageMap[lanugageValue.value]
          return
        }
        if (surveyData.data?.code === 5013) {
          state.researchIsEnd = true
          i18n.locale = languageMap[lanugageValue.value]
          return
        }
        i18n.locale = languageMap[lanugageValue.value]

        state.surveyRule = isTest
          ? surveyRule.data?.data || []
          : surveyData.data?.data?.logics || []
        dealSurveyData()
        if (!isTest || !isReadOnly) {
          getOpenSurveyRun({
            url: window?.location?.href,
            preview: preview === '1' ? 1 : 0
          }).then((res) => {
            window.sessionStorage.removeItem('openSurveyId')
            window.sessionStorage.setItem('openSurveyId', res.data)
          }) //问卷被打开时，调用后端埋点接口
        }
      })
      nextTick(() => {
        setTimeout(() => {
          logCommit()
        }, 1000)
      })
    })

    const endAnswer = (endword) => {
      if (endword) {
        state.endStr = endword
      }
      state.isEnd = true
    }

    const answerAgain = () => {
      state.answerCounts = 0
    }

    return () => {
      const defaultEndWord = `<p class="ql-align-center"><img src="https://storage.wanyol.com/cem-file-data-pub-test/data_upload/996_1658302206649.png"></p><p class="ql-align-center"><span style="background-color: rgb(255, 255, 255); color: rgb(101, 103, 98);">${i18n.t(
        'survy.pushsuccess'
      )}</span></p><p class="ql-align-center"><br></p><p class="ql-align-center"><span style="color: rgb(101, 103, 98);">${i18n.t(
        'survy.timeEnd'
      )}</span><span style="color: rgb(101, 103, 98); background-color: rgb(248, 248, 248);"></span></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p>`
      const isIframe = getQueryString('iframe')
      let languageList: any[] = []
      if (isTest) {
        languageList = getDetailLanguauesState.data?.data?.selectSurvey
        languageList?.forEach((element) => {
          element.language = sourceI18n.t(
            `common.language${element.languageCode}`
          )
        })
      } else {
        for (const [key, value] of Object.entries(
          surveyData.data?.data?.surveyLanguageListDto?.listLanguage ?? {}
        )) {
          languageList.push({
            languageCode: key,
            language: value
          })
        }
      }
      if (state.answerCounts && !state.researchIsEnd && !urlInstanceId.value) {
        return (
          <div class="had-answer-container">
            <img src={TimeEndIcon}></img>
            <div class="research-end-word">{i18n.t('survy.submitted')}</div>
            <el-button onClick={() => answerAgain()}>
              {i18n.t('survy.answerAgain')}
            </el-button>
          </div>
        )
      } else {
        return (
          <div
            style={{ 'pointer-events': isReadOnly ? 'none' : 'auto' }}
            class={isIframe ? 'ct_iframe anstain_contain' : 'anstain_contain'}>
            {keyForRender.value && (
              <div
                class={
                  state.surveyDetial.surveyConfig.isOnePageOneTopic
                    ? 'test-survey-container ql-editor ql-container bgc_white'
                    : 'test-survey-container ql-editor ql-container'
                }>
                {/* 等待联调，当出现不止一种语言时才出现 */}
                {!state.researchIsEnd && languageList?.length > 1 && (
                  <div
                    class={
                      isIframe ? 'language_select' : 'language_select needTop'
                    }>
                    <div class="select" id="languageSelect">
                      <el-select
                        style={{ width: '160px !important' }}
                        filterable
                        placeholder=""
                        size="small"
                        value={lanugageValue.value}
                        onchange={(value) => {
                          lanugageValue.value = value
                          let params = !isTest
                            ? {
                                collectorPath: code,
                                triggerId: triggerId ? triggerId : 0,
                                languageCode: value
                              }
                            : {
                                isDraft,
                                surveyId,
                                languageCode: value
                              }
                          getSurveyData(params).then((res) => {
                            i18n.locale = languageMap[value]
                            // console.log(i18n.locale)
                            dealSurveyData()
                            keyForRender.value = false
                            instance?.proxy.$nextTick(() => {
                              keyForRender.value = true
                            })
                          })
                          //等待联调，调用重新渲染问卷的接口
                        }}>
                        {languageList?.map((item: any) => {
                          return (
                            <el-option
                              key={item.languageCode}
                              label={item.language}
                              value={item.languageCode}></el-option>
                          )
                        })}
                      </el-select>
                    </div>
                  </div>
                )}
                {/* 是否配置是一页一题 */}
                {state.researchIsEnd ? (
                  <div class="research-end-container">
                    <img src={TimeEndIcon}></img>
                    <div class="research-end-word">
                      {i18n.t('survy.timeEnd')}
                    </div>
                  </div>
                ) : (
                  <div
                    class={
                      getQueryString('iframe')
                        ? 'answer_pack_iframe'
                        : 'answer_pack'
                    }>
                    {state.surveyDetial.topics.length > 0 &&
                      state.surveyDetial.surveyConfig.isOnePageOneTopic &&
                      !state.isEnd && (
                        <OnePageSurvey
                          onendAnswer={(endword) => endAnswer(endword)}
                          surveyRule={state.surveyRule}
                          code={code}
                          surveyId={surveyId}
                          createLanguageCode={
                            state.surveyDetial.surveyConfig[
                              'createLanguageCode'
                            ]
                          }
                          startTime={startTime}
                          isTest={isTest}
                          i18n={i18n}
                          surveyData={state.surveyDetial}></OnePageSurvey>
                      )}
                    {state.surveyDetial.topics.length > 0 &&
                      !state.surveyDetial.surveyConfig.isOnePageOneTopic &&
                      !state.isEnd && (
                        <NormalSurvey
                          onendAnswer={(endword) => endAnswer(endword)}
                          surveyRule={state.surveyRule}
                          surveyId={surveyId}
                          createLanguageCode={
                            state.surveyDetial.surveyConfig[
                              'createLanguageCode'
                            ]
                          }
                          startTime={startTime}
                          isTest={isTest}
                          code={code}
                          i18n={i18n}
                          surveyData={state.surveyDetial}></NormalSurvey>
                      )}
                    {state.isEnd && (
                      <EndAnswer
                        config={state.surveyDetial.surveyConfig}
                        endStr={state.endStr || defaultEndWord}></EndAnswer>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )
      }
    }
  }
})

export default TestSurvey
